var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.exportDialog ? _c('export-dialog', {
    attrs: {
      "filename": "Épület napló",
      "api-endpoint": "/log/exportBuilding",
      "additional-post-params": {
        period: _vm.search.period,
        from: _vm.search.from,
        to: _vm.search.to
      }
    },
    on: {
      "close": function ($event) {
        _vm.exportDialog = false;
      }
    }
  }) : _vm._e(), _c('title-row', {
    attrs: {
      "title": "Épület napló",
      "subtitle": _vm.dataTable.itemsLength === -1 ? 'Betöltés...' : `${_vm.dataTable.itemsLength} log van a rendszerben`,
      "breadcrumb-items": [{
        text: 'Naplók',
        disabled: true
      }, {
        text: 'Épület',
        disabled: true
      }]
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('title-row-button', {
          attrs: {
            "color": _vm.polling ? 'primary' : 'muted'
          },
          on: {
            "click": _vm.togglePolling
          }
        }, [!_vm.loading ? _c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v(_vm._s(_vm.polling ? 'mdi-stop' : 'mdi-play'))]) : _c('v-progress-circular', {
          staticClass: "mr-2 ml-n1",
          attrs: {
            "indeterminate": "",
            "size": "18",
            "width": "2"
          }
        }), _vm._v(" Frissítés ")], 1), _c('title-row-button', {
          attrs: {
            "color": "muted"
          },
          on: {
            "click": function ($event) {
              _vm.exportDialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-file-export")]), _vm._v(" Exportálás ")], 1)];
      },
      proxy: true
    }])
  }), _c('v-expansion-panels', {
    staticClass: "mb-4 rounded-xl overflow-hidden",
    attrs: {
      "mandatory": !!Object.values(_vm.search).find(function (e) {
        return e !== '';
      }),
      "flat": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('span', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-filter")]), _vm._v(" Szűrés ")], 1)]), _c('v-expansion-panel-content', [_c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": 12,
      "md": 3,
      "lg": 3
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Épület",
      "items": _vm.buildings,
      "item-text": "name",
      "item-value": "id",
      "dense": "",
      "clearable": "",
      "hide-details": "",
      "placeholder": "Összes",
      "multiple": "",
      "filled": ""
    },
    on: {
      "change": _vm.searchChangeEventHandler
    },
    model: {
      value: _vm.search.building_ids,
      callback: function ($$v) {
        _vm.$set(_vm.search, "building_ids", $$v);
      },
      expression: "search.building_ids"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "md": 3,
      "lg": 3
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Kontroller",
      "items": _vm.controllers,
      "item-text": "name",
      "item-value": "element_id",
      "dense": "",
      "clearable": "",
      "hide-details": "",
      "placeholder": "Összes",
      "multiple": "",
      "filled": ""
    },
    on: {
      "change": _vm.searchChangeEventHandler
    },
    model: {
      value: _vm.search.controller_ids,
      callback: function ($$v) {
        _vm.$set(_vm.search, "controller_ids", $$v);
      },
      expression: "search.controller_ids"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "md": 3,
      "lg": 3
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Név / Kártyaszám / Vonalkód száma",
      "dense": "",
      "clearable": "",
      "hide-details": "",
      "filled": ""
    },
    on: {
      "input": _vm.searchChangeEventHandler
    },
    model: {
      value: _vm.search.keyphrase,
      callback: function ($$v) {
        _vm.$set(_vm.search, "keyphrase", $$v);
      },
      expression: "search.keyphrase"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "md": 3,
      "lg": 3
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Időkorlát",
      "items": _vm.timePeriods,
      "item-text": "label",
      "item-value": "value",
      "dense": "",
      "hide-details": "",
      "filled": ""
    },
    on: {
      "change": _vm.searchChangeEventHandler
    },
    model: {
      value: _vm.search.period,
      callback: function ($$v) {
        _vm.$set(_vm.search, "period", $$v);
      },
      expression: "search.period"
    }
  })], 1), _vm.search.period === 'custom' ? [_c('v-col', {
    attrs: {
      "cols": 12,
      "md": 3,
      "lg": 2
    }
  }, [_c('v-datetime-picker', {
    attrs: {
      "label": "Időkorlát kezdete",
      "clearable": "",
      "dense": "",
      "date-picker-props": {
        allowedDates: _vm.allowedStartDates
      },
      "time-picker": false,
      "error-messages": _vm.search.from ? '' : 'Kötelező!',
      "filled": ""
    },
    on: {
      "change": _vm.searchChangeEventHandler
    },
    model: {
      value: _vm.search.from,
      callback: function ($$v) {
        _vm.$set(_vm.search, "from", $$v);
      },
      expression: "search.from"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12,
      "md": 3,
      "lg": 2
    }
  }, [_c('v-datetime-picker', {
    attrs: {
      "label": "Időkorlát vége",
      "clearable": "",
      "dense": "",
      "date-picker-props": {
        allowedDates: _vm.allowedEndDates
      },
      "time-picker": false,
      "disabled": !_vm.search.from,
      "error-messages": _vm.search.from && !_vm.search.to ? 'Kötelező!' : '',
      "filled": ""
    },
    on: {
      "change": _vm.searchChangeEventHandler
    },
    model: {
      value: _vm.search.to,
      callback: function ($$v) {
        _vm.$set(_vm.search, "to", $$v);
      },
      expression: "search.to"
    }
  })], 1)] : _vm._e()], 2)], 1)], 1)], 1), _c('v-card', {
    staticClass: "rounded-xl",
    attrs: {
      "flat": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "loading": _vm.dataTable.loading,
      "headers": _vm.dataTable.headers,
      "items": _vm.dataTable.items,
      "server-items-length": _vm.dataTable.itemsLength,
      "options": _vm.dataTable.options,
      "footer-props": _vm.$config.dataTableFooterProps,
      "calculate-widths": "",
      "disable-sort": ""
    },
    on: {
      "update:options": function ($event) {
        return _vm.$set(_vm.dataTable, "options", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: `item.created`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', {
          attrs: {
            "title": _vm._f("moment")(item.created, _vm.$config.momentFormats.explicit)
          }
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(item.created, 'll LTS')) + " ")])];
      }
    }, {
      key: `item.cardowner_name`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('div', {
          staticClass: "font-weight-bold d-flex align-center gap-x-1"
        }, [_c('span', [_vm._v(_vm._s(item.cardowner_name))]), item.element_id && _vm.hasRight('CARD_READ') ? _c('v-btn', {
          staticClass: "action-btn",
          attrs: {
            "x-small": "",
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.openNewtab(item.element_id, 'CardEditor');
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1) : _vm._e()], 1), _c('div', [_vm._v(" " + _vm._s(item.card_rule_prefix + item.card_number || item.barcode_number) + " ")])];
      }
    }, {
      key: `item.controller_name`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticClass: "d-flex align-center gap-x-1"
        }, [_c('span', [_vm._v(_vm._s(item.controller_name))]), item.element_id && _vm.hasRight('DEVICE_READ') ? _c('v-btn', {
          staticClass: "action-btn",
          attrs: {
            "x-small": "",
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.openNewtab(item.controller_id, 'ControllerEditor');
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-open-in-new")])], 1) : _vm._e()], 1)];
      }
    }, {
      key: `item.message`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('div', {
          staticClass: "px-4"
        }, [_vm._v(_vm._s(item.message))])];
      }
    }], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }